var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.configObj
    ? _c("div", { style: _vm.mbConfig }, [
        _c(
          "div",
          { staticClass: "menus", style: _vm.tabBgColor },
          _vm._l(_vm.navlist, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "item shrink",
                class: { on: _vm.curIndex === index },
                style: {
                  color:
                    _vm.curIndex === index
                      ? _vm.checkThemeStyle
                        ? _vm.configObj.checkColor.color[0].item
                        : _vm.mobileTheme
                      : _vm.fontColor,
                },
              },
              [
                _vm._v("\n      " + _vm._s(item.val) + " "),
                _c("span", { style: _vm.checkColor }),
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "mobile-page paddingBox",
            class: _vm.bgStyle === 0 ? "" : "pageOn",
            style: _vm.boxStyle,
          },
          [
            _c(
              "div",
              { staticClass: "home_product" },
              [
                _vm.itemStyle == 0
                  ? [
                      _vm.goodslist && _vm.goodslist.length > 0
                        ? _c(
                            "div",
                            { staticClass: "list-wrapper itemA" },
                            _vm._l(_vm.goodslist, function (item, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "item",
                                  style: {
                                    marginBottom: _vm.contentConfig + "px",
                                  },
                                },
                                [
                                  _c("div", { staticClass: "img-box" }, [
                                    item.image
                                      ? _c("img", {
                                          style: _vm.contentStyle,
                                          attrs: { src: item.image, alt: "" },
                                        })
                                      : _c(
                                          "div",
                                          {
                                            staticClass: "empty-box",
                                            style: _vm.contentStyle,
                                          },
                                          [
                                            _c("span", {
                                              staticClass:
                                                "iconfont icontupian",
                                            }),
                                          ]
                                        ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "info" }, [
                                    _c("div", { staticClass: "hd" }, [
                                      _c("div", { staticClass: "text" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "title line2",
                                            style: _vm.titleColor,
                                          },
                                          [
                                            _vm.titleShow
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(item.storeName)
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "price",
                                        style: _vm.priceColor,
                                      },
                                      [
                                        _vm.priceShow
                                          ? _c("div", { staticClass: "num" }, [
                                              _vm._v("\n                  ￥"),
                                              _c("span", [
                                                _vm._v(_vm._s(item.price)),
                                              ]),
                                            ])
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.soldShow
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "sold",
                                            style: _vm.soldColor,
                                          },
                                          [
                                            _vm._v(
                                              "\n                已售 " +
                                                _vm._s(
                                                  Math.floor(item.sales) +
                                                    Math.floor(item.ficti) || 0
                                                ) +
                                                " " +
                                                _vm._s(item.unitName) +
                                                "\n              "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]
                              )
                            }),
                            0
                          )
                        : _c("div", { staticClass: "list-wrapper itemA" }, [
                            _c(
                              "div",
                              {
                                staticClass: "item",
                                style: {
                                  marginBottom: _vm.contentConfig + "px",
                                },
                              },
                              [
                                _c("div", { staticClass: "img-box" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "empty-box",
                                      style: _vm.contentStyle,
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "iconfont icontupian",
                                      }),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "info" }, [
                                  _c("div", { staticClass: "hd" }, [
                                    _c("div", { staticClass: "text" }, [
                                      _c(
                                        "div",
                                        { staticClass: "title line2" },
                                        [
                                          _vm.titleShow
                                            ? _c(
                                                "span",
                                                { style: _vm.titleColor },
                                                [_vm._v("商品名称")]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "price",
                                      style: _vm.priceColor,
                                    },
                                    [
                                      _vm.priceShow
                                        ? _c("div", { staticClass: "num" }, [
                                            _vm._v("¥"),
                                            _c("span", [_vm._v("199")]),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.soldShow
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "sold",
                                          style: _vm.soldColor,
                                        },
                                        [_vm._v("已售 999 件")]
                                      )
                                    : _vm._e(),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "item",
                                style: {
                                  marginBottom: _vm.contentConfig + "px",
                                },
                              },
                              [
                                _c("div", { staticClass: "img-box" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "empty-box",
                                      style: _vm.contentStyle,
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "iconfont icontupian",
                                      }),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "info" }, [
                                  _c("div", { staticClass: "hd" }, [
                                    _c("div", { staticClass: "text" }, [
                                      _c(
                                        "div",
                                        { staticClass: "title line2" },
                                        [
                                          _vm.titleShow
                                            ? _c(
                                                "span",
                                                { style: _vm.titleColor },
                                                [_vm._v("商品名称")]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "price",
                                      style: _vm.priceColor,
                                    },
                                    [
                                      _vm.priceShow
                                        ? _c("div", { staticClass: "num" }, [
                                            _vm._v("¥"),
                                            _c("span", [_vm._v("199")]),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.soldShow
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "sold",
                                          style: _vm.soldColor,
                                        },
                                        [_vm._v("已售 999 件")]
                                      )
                                    : _vm._e(),
                                ]),
                              ]
                            ),
                          ]),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.itemStyle == 1
                  ? [
                      _vm.goodslist && _vm.goodslist.length > 0
                        ? _c(
                            "div",
                            {
                              staticClass: "list-wrapper itemC",
                              style: { gridGap: _vm.contentConfig + "px" },
                            },
                            _vm._l(_vm.goodslist, function (item, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "item auto",
                                  style: _vm.contentStyle,
                                },
                                [
                                  _c("div", { staticClass: "img-box" }, [
                                    item.image
                                      ? _c("img", {
                                          attrs: { src: item.image, alt: "" },
                                        })
                                      : _c(
                                          "div",
                                          { staticClass: "empty-box" },
                                          [
                                            _c("span", {
                                              staticClass:
                                                "iconfont icontupian",
                                            }),
                                          ]
                                        ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "info acea-row row-column row-between",
                                    },
                                    [
                                      _vm.titleShow
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "hd line2 title",
                                              style: _vm.titleColor,
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(_vm._s(item.storeName)),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("div", [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "price",
                                            style: _vm.priceColor,
                                          },
                                          [
                                            _vm.priceShow
                                              ? _c(
                                                  "div",
                                                  { staticClass: "num" },
                                                  [
                                                    _vm._v(
                                                      "\n                    ¥"
                                                    ),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(item.price)
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.soldShow
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "sold",
                                                style: _vm.soldColor,
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  已售 " +
                                                    _vm._s(
                                                      Math.floor(item.sales) +
                                                        Math.floor(
                                                          item.ficti
                                                        ) || 0
                                                    ) +
                                                    " " +
                                                    _vm._s(item.unitName) +
                                                    "\n                "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            0
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "list-wrapper itemC",
                              style: { gridGap: _vm.contentConfig + "px" },
                            },
                            [
                              _c("div", { staticClass: "item auto" }, [
                                _c("div", { staticClass: "img-box" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "empty-box",
                                      style: _vm.contentStyle,
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "iconfont icontupian",
                                      }),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "info" }, [
                                  _c("div", { staticClass: "hd acea-row" }, [
                                    _vm.titleShow
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "title line2",
                                            style: _vm.titleColor,
                                          },
                                          [_vm._v("商品名称")]
                                        )
                                      : _vm._e(),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "price",
                                      style: _vm.priceColor,
                                    },
                                    [
                                      _vm.priceShow
                                        ? _c("div", { staticClass: "num" }, [
                                            _vm._v("¥"),
                                            _c("span", [_vm._v("66.66")]),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.soldShow
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "sold",
                                          style: _vm.soldColor,
                                        },
                                        [_vm._v("已售 999 件")]
                                      )
                                    : _vm._e(),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "item auto" }, [
                                _c("div", { staticClass: "img-box" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "empty-box",
                                      style: _vm.contentStyle,
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "iconfont icontupian",
                                      }),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "info" }, [
                                  _c("div", { staticClass: "hd acea-row" }, [
                                    _vm.titleShow
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "title line2",
                                            style: _vm.titleColor,
                                          },
                                          [_vm._v("商品名称")]
                                        )
                                      : _vm._e(),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "price",
                                      style: _vm.priceColor,
                                    },
                                    [
                                      _vm.priceShow
                                        ? _c("div", { staticClass: "num" }, [
                                            _vm._v("¥"),
                                            _c("span", [_vm._v("66.66")]),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.soldShow
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "sold",
                                          style: _vm.soldColor,
                                        },
                                        [_vm._v("已售 999 件")]
                                      )
                                    : _vm._e(),
                                ]),
                              ]),
                            ]
                          ),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.itemStyle == 2
                  ? [
                      _vm.goodslist && _vm.goodslist.length > 0
                        ? _c(
                            "div",
                            {
                              staticClass: "list-wrapper itemB listC",
                              style: { gridGap: _vm.contentConfig + "px" },
                            },
                            _vm._l(_vm.goodslist, function (item, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "item auto" },
                                [
                                  _c("div", { staticClass: "img-box" }, [
                                    item.image
                                      ? _c("img", {
                                          style: _vm.contentStyle,
                                          attrs: { src: item.image, alt: "" },
                                        })
                                      : _c(
                                          "div",
                                          {
                                            staticClass: "empty-box",
                                            style: _vm.contentStyle,
                                          },
                                          [
                                            _c("span", {
                                              staticClass:
                                                "iconfont icontupian",
                                            }),
                                          ]
                                        ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "info acea-row row-column row-between",
                                    },
                                    [
                                      _vm.titleShow
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "hd line2 title",
                                              style: _vm.titleColor,
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(_vm._s(item.storeName)),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("div", [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "price",
                                            style: _vm.priceColor,
                                          },
                                          [
                                            _vm.priceShow
                                              ? _c(
                                                  "div",
                                                  { staticClass: "num" },
                                                  [
                                                    _vm._v(
                                                      "\n                    ¥"
                                                    ),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(item.price)
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.soldShow
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "sold",
                                                style: _vm.soldColor,
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  已售 " +
                                                    _vm._s(
                                                      Math.floor(item.sales) +
                                                        Math.floor(
                                                          item.ficti
                                                        ) || 0
                                                    ) +
                                                    " " +
                                                    _vm._s(item.unitName) +
                                                    "\n                "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            0
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "list-wrapper itemB listC",
                              style: { gridGap: _vm.contentConfig + "px" },
                            },
                            [
                              _c("div", { staticClass: "item auto" }, [
                                _c("div", { staticClass: "img-box" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "empty-box",
                                      style: _vm.contentStyle,
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "iconfont icontupian",
                                      }),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "info" }, [
                                  _c("div", { staticClass: "hd acea-row" }, [
                                    _vm.titleShow
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "title line2",
                                            style: _vm.titleColor,
                                          },
                                          [_vm._v("商品名称")]
                                        )
                                      : _vm._e(),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "price",
                                      style: _vm.priceColor,
                                    },
                                    [
                                      _vm.priceShow
                                        ? _c("div", { staticClass: "num" }, [
                                            _vm._v("¥"),
                                            _c("span", [_vm._v("66.66")]),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.soldShow
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "sold",
                                          style: _vm.soldColor,
                                        },
                                        [_vm._v("已售 999 件")]
                                      )
                                    : _vm._e(),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "item auto" }, [
                                _c("div", { staticClass: "img-box" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "empty-box",
                                      style: _vm.contentStyle,
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "iconfont icontupian",
                                      }),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "info" }, [
                                  _c("div", { staticClass: "hd acea-row" }, [
                                    _vm.titleShow
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "title line2",
                                            style: _vm.titleColor,
                                          },
                                          [_vm._v("商品名称")]
                                        )
                                      : _vm._e(),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "price",
                                      style: _vm.priceColor,
                                    },
                                    [
                                      _vm.priceShow
                                        ? _c("div", { staticClass: "num" }, [
                                            _vm._v("¥"),
                                            _c("span", [_vm._v("66.66")]),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.soldShow
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "sold",
                                          style: _vm.soldColor,
                                        },
                                        [_vm._v("已售 999 件")]
                                      )
                                    : _vm._e(),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "item" }, [
                                _c("div", { staticClass: "img-box" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "empty-box",
                                      style: _vm.contentStyle,
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "iconfont icontupian",
                                      }),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "info" }, [
                                  _c("div", { staticClass: "hd acea-row" }, [
                                    _vm.titleShow
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "title line2",
                                            style: _vm.titleColor,
                                          },
                                          [_vm._v("商品名称")]
                                        )
                                      : _vm._e(),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "price",
                                      style: _vm.priceColor,
                                    },
                                    [
                                      _vm.priceShow
                                        ? _c("div", { staticClass: "num" }, [
                                            _vm._v("¥"),
                                            _c("span", [_vm._v("66.66")]),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.soldShow
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "sold",
                                          style: _vm.soldColor,
                                        },
                                        [_vm._v("已售 999 件")]
                                      )
                                    : _vm._e(),
                                ]),
                              ]),
                            ]
                          ),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.itemStyle == 3
                  ? [
                      _vm.goodslist && _vm.goodslist.length > 0
                        ? _c(
                            "div",
                            { staticClass: "listBig" },
                            _vm._l(_vm.goodslist, function (item, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "itemBig",
                                  style: {
                                    marginBottom: _vm.contentConfig + "px",
                                  },
                                },
                                [
                                  _c("div", { staticClass: "img-box" }, [
                                    item.image
                                      ? _c("img", {
                                          style: _vm.contentStyle,
                                          attrs: { src: item.image, alt: "" },
                                        })
                                      : _c(
                                          "div",
                                          {
                                            staticClass: "empty-box",
                                            style: _vm.contentStyle,
                                          },
                                          [
                                            _c("span", {
                                              staticClass:
                                                "iconfont icontupian",
                                            }),
                                          ]
                                        ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "info" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "hd line2 title",
                                        style: _vm.titleColor,
                                      },
                                      [
                                        _vm.titleShow
                                          ? _c("span", [
                                              _vm._v(_vm._s(item.storeName)),
                                            ])
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "price",
                                        style: _vm.priceColor,
                                      },
                                      [
                                        _vm.priceShow
                                          ? _c("div", { staticClass: "num" }, [
                                              _vm._v("\n                  ¥"),
                                              _c("span", [
                                                _vm._v(_vm._s(item.price)),
                                              ]),
                                            ])
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.soldShow
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "sold",
                                            style: _vm.soldColor,
                                          },
                                          [
                                            _vm._v(
                                              "\n                已售 " +
                                                _vm._s(
                                                  Math.floor(item.sales) +
                                                    Math.floor(item.ficti) || 0
                                                ) +
                                                " " +
                                                _vm._s(item.unitName) +
                                                "\n              "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]
                              )
                            }),
                            0
                          )
                        : _c("div", { staticClass: "listBig" }, [
                            _c(
                              "div",
                              {
                                staticClass: "itemBig",
                                style: {
                                  marginBottom: _vm.contentConfig + "px",
                                },
                              },
                              [
                                _c("div", { staticClass: "img-box" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "empty-box",
                                      style: _vm.contentStyle,
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "iconfont icontupian",
                                      }),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "info" }, [
                                  _c("div", { staticClass: "hd acea-row" }, [
                                    _vm.titleShow
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "title line2",
                                            style: _vm.titleColor,
                                          },
                                          [_vm._v("商品名称")]
                                        )
                                      : _vm._e(),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "price",
                                      style: _vm.priceColor,
                                    },
                                    [
                                      _vm.priceShow
                                        ? _c("div", { staticClass: "num" }, [
                                            _vm._v("¥"),
                                            _c("span", [_vm._v("66.66")]),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.soldShow
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "sold",
                                          style: _vm.soldColor,
                                        },
                                        [_vm._v("已售 999 件")]
                                      )
                                    : _vm._e(),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "itemBig",
                                style: {
                                  marginBottom: _vm.contentConfig + "px",
                                },
                              },
                              [
                                _c("div", { staticClass: "img-box" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "empty-box",
                                      style: _vm.contentStyle,
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "iconfont icontupian",
                                      }),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "info" }, [
                                  _c("div", { staticClass: "hd acea-row" }, [
                                    _vm.titleShow
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "title line2",
                                            style: _vm.titleColor,
                                          },
                                          [_vm._v("商品名称")]
                                        )
                                      : _vm._e(),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "price",
                                      style: _vm.priceColor,
                                    },
                                    [
                                      _vm.priceShow
                                        ? _c("div", { staticClass: "num" }, [
                                            _vm._v("¥"),
                                            _c("span", [_vm._v("66.66")]),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.soldShow
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "sold",
                                          style: _vm.soldColor,
                                        },
                                        [_vm._v("已售 999 件")]
                                      )
                                    : _vm._e(),
                                ]),
                              ]
                            ),
                          ]),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }